enum RewardErrorCodes {
  // Rewards
  OrderInput = "PBREWOrderInput",
  OrderNotFound = "PBREWOrderNotFound",
  OrderCreate = "PBREWOrderCreate",
  OrderInvalidInput = "PBREWOrderInvalidInput",
  OrderSnapshot = "PBREWOrderSnapshot",
  RewardPayment = "PBREWPayment",

  // Rewards saga
  InsufficientStock = "PBRSSInsufficientStock",
  InvalidJSON = "PBRSSInvalidJSON",
  InvalidArgument = "PBRSSInvalidArgument",

  // Rewards catalogue
  RewardInput = "PBRCARewardInput",
  RewardNotFound = "PBRCARewardNotFound",
  RewardFilters = "PBRCARewardFilters",
  RewardURLSlugExists = "PBRCARewardURLSlugExists",
  RewardInternalIdentifierExists = "PBRCARewardInternalIdentifierExists",
  NotAllowed = "PBRCANotAllowed"
}

export default RewardErrorCodes
